import { useEntityRoutesMap } from '../../context';
import { EntityRoutes } from '../../types';
import { Link } from '@tanstack/react-router';

export interface EntityLinkProps {
  name?: string;
  id?: string;
  entity: EntityRoutes;
}

export const EntityLink = ({ name, id, entity }: EntityLinkProps) => {
  const routesMap = useEntityRoutesMap();
  const targetRoute = routesMap.get(entity);

  if (!name && !id) {
    return;
  }

  if (!id || !targetRoute) {
    return <span>{name}</span>;
  }

  return (
    <Link
      to={targetRoute.route.fullPath}
      params={
        {
          [targetRoute.key]: id,
        } as never // Because TanStack tries to resolve parameters, which we don't know here, we have to trick TS
      }
    >
      {name}
    </Link>
  );
};
